import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SubscribeRequest } from '../models/subscribe-request.model';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SubscribeService {
  private apiUrl = environment.apiUrl + '/api/subscribe'; // ha más porton fut, módosítsd

  constructor(private http: HttpClient) {}

  subscribe(request: SubscribeRequest): Observable<string> {
    return this.http.post(this.apiUrl, request, { responseType: 'text' })
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      console.error('Hálózati hiba:', error.error);
    } else {
      console.error(`Backend hiba (${error.status}):`, error.error);
    }
    return throwError(() => new Error(error.error || 'Ismeretlen hiba történt'));
  }
}
